export default {
  PROJECT_UNIT_LAYOUT_PICTURES_SET_LOADING: 'PROJECT_UNIT_LAYOUT_PICTURES_SET_LOADING',

  PROJECT_UNIT_LAYOUT_PICTURES_REQUEST: 'PROJECT_UNIT_LAYOUT_PICTURES_REQUEST',
  PROJECT_UNIT_LAYOUT_PICTURES_FAILURE: 'PROJECT_UNIT_LAYOUT_PICTURES_FAILURE',
  PROJECT_UNIT_LAYOUT_PICTURES_SUCCESS: 'PROJECT_UNIT_LAYOUT_PICTURES_SUCCESS',

  PROJECT_UNIT_LAYOUT_PICTURES_RESET: 'PROJECT_UNIT_LAYOUT_PICTURES_RESET',
};
